import { useState, useEffect } from 'react';
import { ApiClient } from '../services/apiClient';

export interface Insumo {
  id: number;
  codigo: string;
  descripcion: string;
  unidad_medida: string;
  categoria?: string;
  precio_unitario?: number;
  estado: string;
  created_at: string;
  updated_at: string;
}

export interface UseInsumosReturn {
  insumos: Insumo[];
  cargandoInsumos: boolean;
  errorInsumos: string | null;
}

/**
 * Hook para cargar lista de insumos para formularios
 */
export const useInsumos = (): UseInsumosReturn => {
  const [insumos, setInsumos] = useState<Insumo[]>([]);
  const [cargandoInsumos, setCargandoInsumos] = useState(false);
  const [errorInsumos, setErrorInsumos] = useState<string | null>(null);

  useEffect(() => {
    const cargarInsumos = async () => {
      setCargandoInsumos(true);
      setErrorInsumos(null);
      
      try {
        // Usar el nuevo ApiClient sin código de fallback
        const insumosData = await ApiClient.getList<Insumo>('/insumos/lista');
        setInsumos(insumosData);
      } catch (error: any) {
        console.error('❌ Error al cargar insumos:', error);
        setErrorInsumos(error.message || 'Error al cargar insumos');
        setInsumos([]);
      } finally {
        setCargandoInsumos(false);
      }
    };

    cargarInsumos();
  }, []);

  return {
    insumos,
    cargandoInsumos,
    errorInsumos
  };
};

export default useInsumos;
